import type {
  FeedbackPayload,
  Message,
  StateWithSidekick,
  StateWithSidekickChat,
} from '../state';

/** The parts of Sidekick state the lifecycle events are read from. */
export type LifecycleSnapshot = {
  isPanelOpen: boolean;
  conversationId: string | null;
  /** Whether the conversation's metadata has loaded. */
  hasConversation: boolean;
  isStreaming: boolean;
  messages: ReadonlyArray<Message>;
  submittedFeedback: Readonly<Record<string, FeedbackPayload>>;
  /** The question a retry the user started is sending again. */
  retryingQuestion: Message | null;
};

const readRetryingQuestion = ({
  aiSidekickChat: chat,
}: StateWithSidekickChat): Message | null => {
  if (chat.retryingErrorId === null) return null;
  const questionId = chat.errorEvents.find(
    ({ id }) => id === chat.retryingErrorId
  )?.sourceUserMessageId;
  return chat.messages.find(({ id }) => id === questionId) ?? null;
};

/**
 * Reads a lifecycle snapshot from a host store.
 * @param state - Host state holding both Sidekick slices.
 * @returns The snapshot.
 */
export const readLifecycleSnapshot = (
  state: StateWithSidekick & StateWithSidekickChat
): LifecycleSnapshot => ({
  isPanelOpen: state.aiSidekick.isPanelOpen,
  conversationId: state.aiSidekickChat.conversationId,
  hasConversation: state.aiSidekickChat.conversationMetadata !== null,
  isStreaming: state.aiSidekickChat.isStreaming,
  messages: state.aiSidekickChat.messages,
  submittedFeedback: state.aiSidekickChat.submittedFeedback,
  retryingQuestion: readRetryingQuestion(state),
});
